export default __webpack_public_path__ + "static/media/photo--lg--wheel-13.c963da78.jpg";